import AdminPortal from "./AdminPortal";
import Storefront from "./Storefront";

export default function App() {
  const isOperations =
    window.location.pathname.startsWith("/gestao") ||
    window.location.pathname.startsWith("/operacao");
  return isOperations ? <AdminPortal /> : <Storefront />;
}
